<template>
<div class="chapter">
<div class="inner_page">
<p class="title"><a id="page_i">It’s Not About You, Mr. Easter Bunny</a></p><a id="page_i">
<p class="title1">A Love Letter About the True Meaning of Easter</p>
<p class="aut">Soraya Diase Coffelt</p>
<p class="aut1">Illustrated by Tea Seroya</p>
<p class="aut2"><i>The Love Letters Book Series</i></p>
<p class="pub"><img alt="Image" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title01.vue?b89e0eb6